import {
  Button,
  InputAdornment,
  SxProps,
  TextField,
  TextFieldVariants,
  Theme,
} from '@mui/material';
import React from 'react';
import { virtualDetailModalStyle } from '../virtual/VirtualDetailModal.style';
import { roundDown } from '../../shared/utils/Formatter';

interface TokenInputProps {
  maxAmount?: number;
  onChange: (value: string) => void;
  value: string;
  label?: string;
  variant?: TextFieldVariants;
  startAdornment?: JSX.Element;
  sx?: SxProps<Theme>;
}

const TokenInput: React.FC<TokenInputProps> = (props) => {
  const MAX_DECIMALS = 6;

  const onClickMaxBtn = () => {
    if (props.maxAmount) {
      const maxAmount = props.maxAmount.toString();
      props.onChange(roundDown(Number(maxAmount), MAX_DECIMALS).toString());
    }
  };

  const onInputTokenAmount = (value: string) => {
    value = value.replace(/[^0-9.]/g, '');

    let rounding = /\.\d{7,}(?![0-9])/;

    const numberValue = value !== '' ? Number(value) : null;

    if (value && numberValue && numberValue >= 0) {
      if (rounding.test(value) && numberValue >= 0) {
        props.onChange(roundDown(Number(value), MAX_DECIMALS).toString());
      } else {
        props.onChange(value);
      }
    } else {
      props.onChange(isNaN(Number(value)) ? '' : value);
    }
  };

  return (
    <TextField
      variant={props.variant ?? 'outlined'}
      size="small"
      sx={{ mb: 1, ...props.sx }}
      fullWidth
      value={props.value}
      label={props.label}
      onChange={(e) => onInputTokenAmount(e.target.value)}
      InputProps={{
        disableUnderline: true,
        startAdornment: props.startAdornment ?? undefined,
        endAdornment: (
          <>
            {props.maxAmount !== undefined && !isNaN(props.maxAmount) ? (
              <InputAdornment position="end">
                <Button
                  disabled={
                    props.maxAmount === undefined ||
                    Number(roundDown(props.maxAmount, 2)) === 0
                  }
                  sx={virtualDetailModalStyle.btnMax}
                  color="lightPrimary"
                  variant="contained"
                  onClick={onClickMaxBtn}
                >
                  Max
                </Button>
              </InputAdornment>
            ) : (
              ''
            )}
          </>
        ),
      }}
    ></TextField>
  );
};

export default TokenInput;
